import { DataSourceRemoteType } from "@supernova-studio/model";
import { z } from "zod";

export const DTOEventFigmaNodesRendered = z.object({
  type: z.literal("DesignSystem.FigmaNodesRendered"),
  designSystemId: z.string(),
  versionId: z.string(),
  figmaNodePersistentIds: z.string().array(),
});

export const DTOEventDataSourcesImported = z.object({
  type: z.literal("DesignSystem.ImportJobFinished"),
  designSystemId: z.string(),
  versionId: z.string(),
  importJobId: z.string(),
  dataSourceType: DataSourceRemoteType,
  dataSourceIds: z.string().array(),
});

export type DTOEventFigmaNodesRendered = z.infer<typeof DTOEventFigmaNodesRendered>;
export type DTOEventDataSourcesImported = z.infer<typeof DTOEventDataSourcesImported>;
